import React from 'react';
import Game from './components/Game';
import './App.css';

function App() {
  return (
    <div className="w-full h-screen overflow-hidden bg-black">
      <Game />
    </div>
  );
}

export default App;